"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("@material-ui/icons/utils/createSvgIcon"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return (0, _core.createStyles)({
    notSquare: {
      height: '1em',
      width: 'auto'
    }
  });
});
var create = 24 !== 24 || 24 !== 24 ? function (props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      otherProps = _objectWithoutProperties(props, ["classes"]);

  var styles = useStyles();

  var newClasses = _objectSpread({}, classes, {
    root: styles.notSquare + ' ' + (classes.root || '')
  });

  return _react["default"].createElement(_SvgIcon["default"], _extends({
    viewBox: '0 0 ' + 24 + ' ' + 24,
    classes: newClasses
  }, otherProps), _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("path", {
    d: "M18.653 4.64L21 2.294v1.414l-1.64 1.64-.707-.706z"
  }), _react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M9.527 5.495c0 .861-.27 1.52-.81 1.976-.536.456-1.3.684-2.293.684h-.728V11H4V3h2.555c.97 0 1.708.21 2.211.63.507.415.76 1.037.76 1.865zm-3.83 1.27h.557c.522 0 .912-.102 1.171-.307.26-.208.389-.509.389-.903 0-.397-.11-.69-.328-.88-.216-.19-.555-.285-1.018-.285h-.772v2.375z",
    clipRule: "evenodd"
  }), _react["default"].createElement("path", {
    d: "M19 16l3 3-3 3v-2H4v-2h15v-2zm2-3.989v3h-1v-3h1zm0-2.013v-3h-1v3h1zm-6.59.3l-2.121 2.121-.707-.707 2.12-2.121.708.707zm1.414-1.415l2.122-2.12-.708-.708-2.12 2.121.706.707zm-8.538 7.125H8.7l2.175-2.175-.708-.707-2.881 2.882z"
  })));
} : (0, _createSvgIcon["default"])(_react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("path", {
  d: "M18.653 4.64L21 2.294v1.414l-1.64 1.64-.707-.706z"
}), _react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M9.527 5.495c0 .861-.27 1.52-.81 1.976-.536.456-1.3.684-2.293.684h-.728V11H4V3h2.555c.97 0 1.708.21 2.211.63.507.415.76 1.037.76 1.865zm-3.83 1.27h.557c.522 0 .912-.102 1.171-.307.26-.208.389-.509.389-.903 0-.397-.11-.69-.328-.88-.216-.19-.555-.285-1.018-.285h-.772v2.375z",
  clipRule: "evenodd"
}), _react["default"].createElement("path", {
  d: "M19 16l3 3-3 3v-2H4v-2h15v-2zm2-3.989v3h-1v-3h1zm0-2.013v-3h-1v3h1zm-6.59.3l-2.121 2.121-.707-.707 2.12-2.121.708.707zm1.414-1.415l2.122-2.12-.708-.708-2.12 2.121.706.707zm-8.538 7.125H8.7l2.175-2.175-.708-.707-2.881 2.882z"
})), 'RealPower');
var _default = create;
exports["default"] = _default;